// Materialvorsprung aus einer FEN, in Bauerneinheiten aus Sicht von Weiß (positiv = Weiß führt).
const VALUE: Record<string, number> = { p: 1, n: 3, b: 3, r: 5, q: 9 };

export function materialLead(fen: string): number {
  let lead = 0;
  for (const ch of fen.split(' ')[0]) {
    const v = VALUE[ch.toLowerCase()];
    if (v) lead += ch === ch.toLowerCase() ? -v : v;
  }
  return lead;
}
